export default __webpack_public_path__ + "static/media/add-user.9ed9ea51.svg";